import axiosInst from 'api/axios';
import classNames from 'classnames';
import { TextError } from 'components/Error/TextError';
import { useContext, useState } from 'react';
import { AppContext } from 'redux/appReducer';
import styles from './LoginForm.module.scss';

export const LoginForm = () => {
  const { signIn } = useContext(AppContext);
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');

  const [error, setError] = useState('');

  const handleLoginChange = (e) => {
    setLogin(e.target.value);
    setError('');
  };
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    axiosInst()
      .post('/auth/login', { login, password })
      .then((res) => {
        signIn(res.data);
      })
      .catch((e) => {
        console.log(e);
        setError(e?.response?.data?.message);
      });
  };

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <h2>Sign In</h2>
      <label htmlFor='login'>Login</label>
      <input name='login' required type='text' value={login} onChange={handleLoginChange} />
      <label htmlFor='password'>Password</label>
      <input name='password' required type='password' value={password} onChange={handlePasswordChange} />
      {error && <TextError text={error} />}
      <button className={classNames(styles.loginBtn, 'btn')} type='submit'>
        sign in
      </button>
    </form>
  );
};
